<div class='wrapperCodeConfirm'>
  <input #inputRef *ngFor='let item of arrNumbers' maxlength='1' type='number'
         (input)='inputCode(item, $event,inputRef)' (keydown)='keydown(item, $event, inputRef)'
         (focusin)='focus(inputRef,true)' (focusout)='focus(inputRef,false)'>
</div>